import { CerebrumRoom } from '../../components/cards/cerebrumCard/cerebrumCard.types';

export declare namespace Cerebrum {}

export type TCerebrumProps = {
  categories: any;
  setSearchParams: any;
  listModeActive: any;
  setListModeActive: any;
  filters: any;
  removeChecks: any;
  roomInfo: any;
  searchParams: any;
  setSearchValue: any;
  searchValue: string;
  category: string;
  showFilters: boolean;
  setShowFilters: Function;
  infinityLoading: Function;
  scrollLoading: boolean;
  isDataLoading: boolean;
  renderItems: TRoomData;
  showMap: boolean;
};

export const cerebrumCategoryMap = {
  world: 'Country',
  brand: 'Brands',
  gaming: 'Gaming',
} as const;

export type CerebrumCategoryKey = keyof typeof cerebrumCategoryMap;

export type TRoomData = {
  firstEls: CerebrumRoom[];
  secondEls: CerebrumRoom[];
};

export type TCategory = {
  title: string;
  name: string;
  categoryName: string;
  id: string | number;
  onClick: (setSearchParams: Function, searchParams: URLSearchParams) => void;
};
